<div class="box-kit-model-container">
  <h5 class="kit-model-code">{{code}}</h5>
  <p class="kit-model-phy-info font-weight-regular"><ng-container *ngIf="diameters">{{diameters}}&nbsp;/&nbsp;</ng-container>{{voltages}}</p>
</div>
